import { render, staticRenderFns } from "./bread-crumb.vue?vue&type=template&id=de8758c4&"
import script from "./bread-crumb.vue?vue&type=script&lang=js&"
export * from "./bread-crumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports